import { render, staticRenderFns } from "./bundingPhone.vue?vue&type=template&id=a1658cfe&"
import script from "./bundingPhone.vue?vue&type=script&lang=js&"
export * from "./bundingPhone.vue?vue&type=script&lang=js&"
import style0 from "./bundingPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports